import request from 'services/axios'

export const getBankCards = async (pageParam: number) => {
    const { data }: { data: IBankCards } = await request.get(
        `/api/v1/account/bankaccounts/?cursor=${pageParam}`
    )
    return data
}
export const addNewBankCard = async (cardsNumber: string, isIban: boolean) => {
    const { data }: { data: IAddCardNumber } = await request.post(
        `/api/v1/account/bankaccounts/`,
        {
            ...(!isIban ? { card_number: cardsNumber } : { iban: cardsNumber }),
            ownership_type: 'baotmo',
        }
    )
    return data
}

export const verifyNewBankCard = async (cardsNumber: number) => {
    const { data } = await request.patch(
        `/api/v1/account/bankaccounts/${cardsNumber}/`,
        {
            is_member_verified: true,
        }
    )
    return data
}

export const setDefault = async (id: number) => {
    const { data } = await request.post(
        `/api/v1/account/bankaccounts/${id}/setDefault`
    )
    return data
}

export const deleteCard = async (id: number) => {
    const { data } = await request.delete(`/account/bankaccount/${id}/`)
    return data
}

export const historyPayments = async (id: number, pageParams: number) => {
    const { data }: { data: IHistoryCardManagement } = await request.get(
        `/api/v1/payment/transactions/?bank_account=${id}&cursor=${pageParams}`
    )
    return data
}
